import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { Typography } from "components/controls/widget";

interface Props {
    title: React.ReactNode;
}

class PageTitle extends React.PureComponent<Props & WithStyles<typeof styles>> {

    render() {
        const { title, classes } = this.props;
        return <div className={classes.root}>
            <Typography variant="caption">{title}</Typography>
        </div>;
    }
}


export const styles = (theme: Theme) => createStyles({
    root: {
        paddingLeft: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit * 2,
        borderBottom: `1px solid ${theme.palette.primary.light}`
    },
});

export default withStyles(styles)(PageTitle);